import regisMeetingRoom from "../views/adminstration/phonghop/hc-phonghop-index.vue";
import regisMeetingRoomDx from "../views/adminstration/phonghop/PhongHopDx_Index";
import regisMeetingRoomDetail from "../views/adminstration/phonghop/hc-phonghop-detail.vue";
import regisMeetingRoomDetailDx from "../views/adminstration/phonghop/PhongHopDx_Detail.vue";
import getCar from "../views/adminstration/dieuxe/dieuXe_Index.vue";
import getCarDx from "../views/adminstration/dieuxe/dieuXeDotXuat_Index.vue";
import getCarDetail from "../views/adminstration/dieuxe/hc-dieuxe-detail.vue";
import getCarDetailDx from "../views/adminstration/dieuxe/dieuXeDotXuat_Detail.vue";
import regisMeetingRoomCalendar from "../views/adminstration/phonghop/PhongHop_Calendar.vue";
import getCarCalendar from "../views/adminstration/dieuxe/dieuXe_Calendar.vue";
import conclude from "../views/adminstration/ketluan/ketLuanChiDao_Index.vue";
import concludeDetail from "../views/adminstration/ketluan/ketLuanChiDao_Detail.vue";
import bcCVTrongTam from "../views/adminstration/congviectrongtam/bcCVTrongTam_Index.vue";
import bcCVTrongTamDetail from "../views/adminstration/congviectrongtam/bcCVTrongTam_Detail.vue";
import bcQuyCheQuyDinh from "../views/adminstration/quychequydinh/hcQuyCheQuyDinh_Index.vue";
import bcQuyCheQuyDinhDetail from "../views/adminstration/quychequydinh/hcQuyCheQuyDinh_Detail.vue";
import regiscalendarweek from "../views/adminstration/lichtuan/LichTuan_Index.vue";
import regiscalendarweekCalendar from "../views/adminstration/lichtuan/LichTuan_Calendar.vue";
import regiscalendarweekDetail from "../views/adminstration/lichtuan/LichTuan_Detail.vue";
import administrationTools from "../views/adminstration/tools/Tool_Index";
import administrationToolsDetail from "../views/adminstration/tools/Tool_Detail";
import bookflight from "../views/adminstration/vemaybay/Vemaybay_Index.vue";
import bookflightDetail from "../views/adminstration/vemaybay/hc-maybay-detail";
import bookHotel from "../views/adminstration/khachsan/hc-ks-index.vue";
import bookHotelDetail from "../views/adminstration/khachsan/hc-ks-detail.vue";
import suaChuaNho from "../views/adminstration/suachuanho/hc-scn-index.vue";
import suaChuaNhoDetail from "../views/adminstration/suachuanho/hc-scn-detail.vue";
import luongVb from "../views/adminstration/luongvanban/luongVb_Index.vue";
import luongVbDetail from "../views/adminstration/luongvanban/luongVb_Detail";
import luongVbDetailDv from "../views/adminstration/luongvanban/luongVb_DetailDonVi";
import luongVbDetailSteps from "../views/adminstration/luongvanban/luongVb_DetailSteps";
import luongVbDetailHistory from "../views/adminstration/luongvanban/luongVb_DetailHistory";
import luongVbDetailReturn from "../views/adminstration/luongvanban/luongVb_DetailReturn";
import luongVbDetailReceive from "../views/adminstration/luongvanban/luongVb_DetailReceive";
import luongVbDetailReport from "../views/adminstration/luongvanban/luongVb_DetailReport";
import hcCaseCalendarAttachment from "../views/adminstration/lichtuan/hcCaseCalendarAttachment";
import rankingReasonIndex from "../views/adminstration/reason/ranking-reason-index";
import hotroyeucauIndex from "../views/adminstration/hotroyeucau/hotroyeucau-index";
import vanphongphamIndex from "../views/adminstration/vanphongpham/vanphongpham-index";
import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";

export default [
  /*Route đăng ký phòng họp */
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom",
    name: "adminstration-index",
    component: regisMeetingRoom,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP
      )
    }
  },
  /*Route xem chi tiết từng yêu cầu đăng ký phòng họp*/
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom/detail/:id",
    name: "adminstration-detail",
    components: {
      default: regisMeetingRoom,
      detail: regisMeetingRoomDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP
      )
    }
  },
  /*Route xem lịch đăng ký phòng họp  */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom/calendar",
    name: "adminstration-regisRoomCalendar",
    components: {
      default: regisMeetingRoom,
      detail: regisMeetingRoomCalendar
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP
      )
    }
  },
  /*Route đăng ký phòng họp đột xuất*/
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom-dx",
    name: "adminstration-dx",
    component: regisMeetingRoomDx,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOPDOTXUAT
      )
    }
  },
  /*Route xem chi tiết từng yêu cầu đăng ký phòng họp đột xuất*/
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom-dx/detail/:id",
    name: "adminstration-detail-dx",
    components: {
      default: regisMeetingRoomDx,
      detail: regisMeetingRoomDetailDx
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOPDOTXUAT
      )
    }
  },
  /*Route xem lịch đăng ký phòng họp  */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom-dx/calendar",
    name: "adminstration-dx-regisRoomCalendar",
    components: {
      default: regisMeetingRoomDx,
      detail: regisMeetingRoomCalendar
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOPDOTXUAT
      )
    }
  },
  /*Route điều xe */
  /*Route index*/
  {
    path: "/app/:userDeptRoleId/administrasion/getcar",
    name: "adminstration-getCar",
    component: getCar,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE
      )
    }
  },
  /*Route xem chi tiết từng yêu cầu điều xe */
  {
    path: "/app/:userDeptRoleId/administrasion/getcar/detail/:id",
    name: "adminstration-getCarDetail",
    components: {
      default: getCar,
      detail: getCarDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE
      )
    }
  },
  /*Route xem lịch điều xe */
  {
    path: "/app/:userDeptRoleId/administrasion/getcar/calendar",
    name: "adminstration-getCarCalendar",
    components: {
      default: getCar,
      detail: getCarCalendar
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE
      )
    }
  },
  /*Route điều xe khẩn cấp */
  /*Route index*/
  {
    path: "/app/:userDeptRoleId/administrasion/getcar-dx",
    name: "adminstration-getCar-dx",
    component: getCarDx,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXEDOTXUAT
      )
    }
  },
  /*Route xem chi tiết từng yêu cầu điều xe khẩn cấp*/
  {
    path: "/app/:userDeptRoleId/administrasion/getcar-dx/detail/:id",
    name: "adminstration-getCarDetail-dx",
    components: {
      default: getCarDx,
      detail: getCarDetailDx
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXEDOTXUAT
      )
    }
  },
  /*Route xem lịch điều xe */
  {
    path: "/app/:userDeptRoleId/administrasion/getcar-dx/calendar",
    name: "adminstration-dx-getCarCalendar",
    components: {
      default: getCar,
      detail: getCarCalendar
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXEDOTXUAT
      )
    }
  },
  /*Router theo dõi kết luận chỉ đạo*/
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/conclude",
    name: "adminstration-conclude",
    component: conclude,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_THEODOIKETLUANCHIDAO
      )
    }
  },
  /*Route chi tiết kết luận chỉ đạo */
  {
    path: "/app/:userDeptRoleId/administrasion/conclude/detail/:id",
    name: "adminstration-concludeDetail",
    components: {
      default: conclude,
      detail: concludeDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_THEODOIKETLUANCHIDAO
      )
    }
  },
  /*Router Công việc trọng tâm*/
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/bcCVTrongTam",
    name: "adminstration-bcCVTrongTam",
    component: bcCVTrongTam,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_CONGVIECTRONGTAM
      )
    }
  },
  /*Route chi tiết Công việc trọng tâm */
  {
    path: "/app/:userDeptRoleId/administrasion/bcCVTrongTam/detail/:id",
    name: "adminstration-bcCVTrongTamDetail",
    components: {
      default: bcCVTrongTam,
      detail: bcCVTrongTamDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_CONGVIECTRONGTAM
      )
    }
  },
    /*Router Quy chế, quy định*/
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/quyCheQuyDinh",
    name: "adminstration-quyCheQuyDinh",
    component: bcQuyCheQuyDinh,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_QUYCHEQUYDINHQUYTRINH
      )
    }
  },
  /*Route chi tiết Quy chế, quy định */
  {
    path: "/app/:userDeptRoleId/administrasion/quyCheQuyDinh/detail/:id",
    name: "adminstration-quyCheQuyDinhDetail",
    components: {
      default: bcQuyCheQuyDinh,
      detail: bcQuyCheQuyDinhDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_QUYCHEQUYDINHQUYTRINH
      )
    }
  },
  /* Router lịch tuần */
  /* Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/hcCaseCalendarAttachment",
    name: "hcCaseCalendarAttachment",
    component: hcCaseCalendarAttachment,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/regiscalendarweek",
    name: "adminstration-regiscalendarweek",
    component: regiscalendarweek,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/regiscalendarweek/calendar",
    name: "adminstration-regiscalendarweekCalendar",
    components: {
      default: regiscalendarweek,
      detail: regiscalendarweekCalendar
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN
      )
    }
  },

  //chi tiết lịch tuần
  {
    path: "/app/:userDeptRoleId/administrasion/regiscalendarweek/detail/:id",
    name: "adminstration-regiscalendarweek-detail",
    components: {
      default: regiscalendarweek,
      detail: regiscalendarweekDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN
      )
    }
  },

  // Tool index
  {
    path: "/app/:userDeptRoleId/toolchc",
    name: "administration-tools",
    component: administrationTools,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.CAUHINH
      )
    }
  },
  // Tool detail
  {
    path: "/app/:userDeptRoleId/toolchc/detail/:deptId/:flowCode",
    name: "administration-tools-detail",
    components: {
      default: administrationTools,
      detail: administrationToolsDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.CAUHINH
      )
    }
  },

  // VE MAY BAY
  // index
  {
    path: "/app/:userDeptRoleId/administrasion/bookflight",
    name: "adminstration-bookflight",
    component: bookflight,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_VEMAYBAY
      )
    }
  },
  //chi tiết
  {
    path: "/app/:userDeptRoleId/administrasion/bookflight/detail/:id",
    name: "adminstration-bookflight-detail",
    components: {
      default: bookflight,
      detail: bookflightDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_VEMAYBAY
      )
    }
  },

  // KHACH SAN
  // index
  {
    path: "/app/:userDeptRoleId/administrasion/bookhotel",
    name: "adminstration-bookHotel",
    component: bookHotel,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_KHACHSAN
      )
    }
  },
  //chi tiết
  {
    path: "/app/:userDeptRoleId/administrasion/bookhotel/detail/:id",
    name: "adminstration-bookHotel-detail",
    components: {
      default: bookHotel,
      detail: bookHotelDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.HANHCHINH_KHACHSAN
      )
    }
  },

  // SUA CHUA NHO
  // index
  {
    path: "/app/:userDeptRoleId/administrasion/suaChuaNho",
    name: "adminstration-suaChuaNho",
    component: suaChuaNho,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.SUA_CHUA_NHO
      )
    }
  },
  //chi tiết
  {
    path: "/app/:userDeptRoleId/administrasion/suaChuaNho/detail/:id",
    name: "adminstration-suaChuaNho-detail",
    components: {
      default: suaChuaNho,
      detail: suaChuaNhoDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.SUA_CHUA_NHO
      )
    }
  },

  /*Route theo doi luong van ban ky tuoi - index*/
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan",
    name: "vbLuongVanBan",
    component: luongVb,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detail/:id",
    name: "vbLuongVanBan-detail",
    components: {
      default: luongVb,
      detail: luongVbDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detailDv/:id",
    name: "vbLuongVanBan-detailDv",
    components: {
      default: luongVb,
      detail: luongVbDetailDv
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detailSteps/:id",
    name: "vbLuongVanBan-detailSteps",
    components: {
      default: luongVb,
      detail: luongVbDetailSteps
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detailHistory/:id",
    name: "vbLuongVanBan-detailHistory",
    components: {
      default: luongVb,
      detail: luongVbDetailHistory
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detailReturn/:id",
    name: "vbLuongVanBan-detailReturn",
    components: {
      default: luongVb,
      detail: luongVbDetailReturn
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detailReceive/:id",
    name: "vbLuongVanBan-detailReceive",
    components: {
      default: luongVb,
      detail: luongVbDetailReceive
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/administrasion/vbLuongVanBan/detailReport/:id",
    name: "vbLuongVanBan-detailReport",
    component: {
      default: luongVb,
      detail: luongVbDetailReport
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.VB_DI_LUONGVB
      )
    }
  },

  {
    path: "/app/:userDeptRoleId/administrasion/rankingReasonIndex",
    name: "rankingReasonIndex",
    component: rankingReasonIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.CAUHINH_RANKINGREASON
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/hotroyeucau",
    name: "hotroyeucauIndex",
    component: hotroyeucauIndex
  },

  {
    path: "/app/:userDeptRoleId/vanphongpham",
    name: "vanphongphamIndex",
    component: vanphongphamIndex
  }
];



// WEBPACK FOOTER //
// ./src/router/adminstration.js